import { FC, useCallback } from 'react';
import { FixtureItem as FixtureItemType } from '../../../../types';

import './FixtureItem.less';

interface FixtureItemProps {
  item: FixtureItemType;
  onDragFixture: (item: FixtureItemType) => void;
}

const FixtureItem: FC<FixtureItemProps> = ({ item, onDragFixture }) => {
  const handleDragStart = useCallback(
    (e: React.DragEvent, item: FixtureItemType) => {
      onDragFixture(item);
      e.dataTransfer.setData('text/plain', item.id);
      e.dataTransfer.effectAllowed = 'copy';
    },
    [onDragFixture]
  );

  return (
    <div
      draggable
      className="fixture-item-wrapper"
      onDragStart={(e) => handleDragStart(e, item)}
    >
      {item.imageUrl ? (
        <div
          className="fixture-item-box fixture-item-image"
          style={{
            backgroundImage: `url(${item.imageUrl})`,
          }}
        />
      ) : (
        <div
          className="fixture-item-box"
          style={{ backgroundColor: item.color }}
        />
      )}
      <div className="fixture-item-label">{item.name}</div>
    </div>
  );
};

export default FixtureItem;
